import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageViewerConfig } from '@hreimer/angular-image-viewer';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnInit {
  title = 'Image Viewer';
  images: string[] = [];
  imageIndex = 0;

  config: ImageViewerConfig = {
    btnContainerClass: 'btn-wrapper',
    btnClass: 'btn btn-hover-primary px-1',
    btnSubClass: 'material-icons font-size-xl',
    zoomFactor: 0.1,
    containerBackgroundColor: '#fff',
    wheelZoom: true,
    allowFullscreen: false,
    allowKeyboardNavigation: true,
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      rotateClockwise: true,
      rotateCounterClockwise: true,
      next: false,
      prev: false,
      reset: true
    },
    btnIcons: {
      zoomIn: {
        text: 'zoom_in'
      },
      zoomOut: {
        text: 'zoom_out'
      },
      rotateClockwise: {
        text: 'rotate_right'
      },
      rotateCounterClockwise: {
        text: 'rotate_left'
      },
      next: {
        text: 'arrow_right'
      },
      prev: {
        text: 'arrow_left'
      },
      fullscreen: {
        text: 'fullscreen'
      },
      reset: {
        text: 'restore'
      },
    }
  };

  constructor(
    public dialogRef: MatDialogRef<ImageViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }

  ngOnInit() {
    if (this.dialogData) {
      this.title = this.dialogData.title;
      // console.log(this.dialogData);
      if (this.dialogData.images && this.dialogData.images.length) {
        this.images = [...this.dialogData.images];
      }
    }
  }

  closeModalDialog(): void {
    this.dialogRef.close();
  }

}
